import api from './api';

const commercialProposalService = {
  getAllProposals: async (params = {}) => {
    try {
      const response = await api.get('/commercial-proposal', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting commercial proposal records:', error);
      throw error;
    }
  },

  getProposalById: async (id) => {
    try {
      const response = await api.get(`/commercial-proposal/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting commercial proposal record:', error);
      throw error;
    }
  },

  createProposal: async (proposalData) => {
    try {
      const response = await api.post('/commercial-proposal', proposalData);
      return response.data;
    } catch (error) {
      console.error('Error creating commercial proposal record:', error);
      throw error;
    }
  },

  updateProposal: async (id, proposalData) => {
    try {
      const response = await api.put(`/commercial-proposal/${id}`, proposalData);
      return response.data;
    } catch (error) {
      console.error('Error updating commercial proposal record:', error);
      throw error;
    }
  },

  deleteProposal: async (id) => {
    try {
      const response = await api.delete(`/commercial-proposal/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting commercial proposal record:', error);
      throw error;
    }
  },

  bulkDeleteProposals: async (proposalIds) => {
    try {
      const response = await api.delete('/commercial-proposal/bulk', {
        data: { proposalIds }
      });
      return response.data;
    } catch (error) {
      console.error('Error bulk deleting commercial proposal records:', error);
      throw error;
    }
  },

  getProposalStats: async () => {
    try {
      const response = await api.get('/commercial-proposal/stats');
      return response.data;
    } catch (error) {
      console.error('Error getting commercial proposal stats:', error);
      throw error;
    }
  },

  getProposalsByStatus: async (status) => {
    try {
      const response = await api.get(`/commercial-proposal/status/${status}`);
      return response.data;
    } catch (error) {
      console.error('Error getting proposals by status:', error);
      throw error;
    }
  },

  getProposalsByOwner: async (ownerId) => {
    try {
      const response = await api.get(`/commercial-proposal/owner/${ownerId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting proposals by owner:', error);
      throw error;
    }
  },

  getProposalsByType: async (type) => {
    try {
      const response = await api.get(`/commercial-proposal/type/${type}`);
      return response.data;
    } catch (error) {
      console.error('Error getting proposals by type:', error);
      throw error;
    }
  },

  getExpiringProposals: async (days = 7) => {
    try {
      const response = await api.get('/commercial-proposal/expiring', { params: { days } });
      return response.data;
    } catch (error) {
      console.error('Error getting expiring proposals:', error);
      throw error;
    }
  },

  getHighValueProposals: async (minValue = 100000) => {
    try {
      const response = await api.get('/commercial-proposal/high-value', { params: { minValue } });
      return response.data;
    } catch (error) {
      console.error('Error getting high value proposals:', error);
      throw error;
    }
  },

  getProposalsByDateRange: async (startDate, endDate) => {
    try {
      const response = await api.get('/commercial-proposal/date-range', { params: { startDate, endDate } });
      return response.data;
    } catch (error) {
      console.error('Error getting proposals by date range:', error);
      throw error;
    }
  },

  // Version Management Methods
  createNewVersion: async (id, versionData) => {
    try {
      const response = await api.post(`/commercial-proposal/${id}/versions`, versionData);
      return response.data;
    } catch (error) {
      console.error('Error creating new version:', error);
      throw error;
    }
  },

  getVersionHistory: async (id) => {
    try {
      const response = await api.get(`/commercial-proposal/${id}/versions`);
      return response.data;
    } catch (error) {
      console.error('Error getting version history:', error);
      throw error;
    }
  },

  getVersionComparison: async (id, version1, version2) => {
    try {
      const response = await api.get(`/commercial-proposal/${id}/versions/compare`, { 
        params: { version1, version2 } 
      });
      return response.data;
    } catch (error) {
      console.error('Error getting version comparison:', error);
      throw error;
    }
  },

  restoreVersion: async (id, versionNumber) => {
    try {
      const response = await api.post(`/commercial-proposal/${id}/versions/restore`, { versionNumber });
      return response.data;
    } catch (error) {
      console.error('Error restoring version:', error);
      throw error;
    }
  },

  getRevisionAnalytics: async (startDate, endDate) => {
    try {
      const response = await api.get('/commercial-proposal/analytics/revisions', { 
        params: { startDate, endDate } 
      });
      return response.data;
    } catch (error) {
      console.error('Error getting revision analytics:', error);
      throw error;
    }
  }
};

export default commercialProposalService;
